<template>
  <div id="contenedor-configuracion-plantillas-generador-listado-desktop">

      <v-list
        two-line
        dense
        flat
        nav >
        <v-list-item>
          <v-text-field
            v-model="plantillaBusca"
            dense
            filled
            rounded
            hide-details
            full-width
            placeholder="Buscar..."
            append-icon="mdi-magnify"
          >
          </v-text-field>
        </v-list-item>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
        <v-list-item
          v-for="(plantilla) in getPlantillasModulo"
          :key="plantilla.id"
          :plantilla="plantilla">
          <v-list-item-content>
            <v-list-item-title
              v-text="plantilla.nombre">
            </v-list-item-title>
            <v-list-item-subtitle>
              <fecha-humano :fecha="new Date(plantilla.createdAt)"></fecha-humano>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action >
            <v-btn v-if="plantilla.path !== ''" @click="seleccionarPlantilla(plantilla)"
              :loading="plantilla.id===mostrarLoading">
              <v-icon >
                mdi-file-download-outline
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

  </div>
</template>

<script>
import PLANTILLA_POR_MODULO from '@/graphql/querys/administracion/configuracion/plantillas/plantillaPorModulo.gql';
import FechaHumano from '@/components/FechaHumano.vue';
import mixGenerarPlantilla from '@/helpers/mixGenerarPlantilla';

export default {
  name: 'ConfiguracionPlantillasGeneradorListadoDesktop',
  mixins: [mixGenerarPlantilla],
  props: {
    modulo: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: true,
    },
    idarchivo: {
      type: String,
      required: false,
      default: 'plantilla',
    },
  },
  components: {
    FechaHumano,

  },
  data() {
    return {
      plantilla: Object,
      mostrarLoading: null,
      datosConFormato: Object,
      plantillaBusca: '',

    };
  },
  methods: {
    // Llama a mixGenerarPlantilla del microservicio de word
    async generaWord() {
      const datosConFormato = this.datos;
      const nombrePlantilla = this.plantilla.path;
      const nombreArchivoGenerado = `${this.idarchivo}_${this.plantilla.nombre}`;
      // console.log('datos', datosConFormato);
      await this.mixGenerarPlantilla({
        data: {
          plantilla: nombrePlantilla,
          datos: datosConFormato,
        },
      }, nombreArchivoGenerado);
      this.mostrarLoading = null;
    },
    seleccionarPlantilla(plantilla) {
      this.plantilla = plantilla;
      this.mostrarLoading = plantilla.id;
      this.generaWord();
    },
  },
  apollo: {
    plantillaPorModulo: {
      query: PLANTILLA_POR_MODULO,
      variables() {
        return {
          modulo: this.modulo,
        };
      },
    },
  },
  computed: {
    getPlantillasModulo() {
      if (!this.plantillaPorModulo) {
        return [];
      }
      return this.plantillaPorModulo.filter(
        (p) => (p.nombre.toUpperCase().includes(this.plantillaBusca.toUpperCase())),
      ).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },

};

</script>

<style lang="scss">

</style>
